export const T = {
  en: {
    disclaimer: "This information is for education. It does not replace care from a qualified healthcare professional.",
    disclaimerLong: "This information is for educational purposes only. It does not replace care from a qualified healthcare professional.",
    eyebrow: "Information is Power",
    forTeens: "Information is Power · For Teens",
    toc: "In this guide · tap to open",
    download: "Download printable PDF",
    share: "Share this guide",
    text: "Text it",
    copy: "Copy link",
    downloading: "Your printable guide is downloading.",
    copied: "Link and message copied. Paste it anywhere to share.",
    shareMsg: (title, link) => `I care about you and found this helpful: "${title}" from Bright Stories Network. ${link}`,
    helpNow: "If you need help now, call or text 988.",
    guidesTitle: "Understand what's happening, and how to help",
    guidesSub: "Choose the guide that fits what you need right now.",
    readGuide: "Read this guide →",
    packetTitle: "For schools & counselors",
    packetSub: "Every guide, the teen guide, and the fill-in safety plan in one printable packet with a cover and contents page.",
    packetBtn: "Download the packet",
    packetToast: "The school & counselor packet is downloading.",
    planToast: "Your fill-in safety plan is downloading.",
    pdf: {
      label: "INFORMATION IS POWER", teens: "FOR TEENS", plan: "MY SAFETY PLAN",
      crisis: "Call or text 988 (Suicide & Crisis Lifeline)  ·  Text HOME to 741741  ·  In immediate danger, call 911.",
      footerHelp: "Need help now? Call or text 988.", readOnline: "Read online", page: "Page", of: "of",
      planTitle: "My Safety Plan",
      planIntro: "Fill this in on your phone or computer, or print it and write by hand. Keep it somewhere you will see it. Share it with someone you trust. You matter.",
      planCrisisH: "If I am in crisis right now",
      planCrisis1: "988 Suicide & Crisis Lifeline: call or text 988  ·  Crisis Text Line: text HOME to 741741",
      planCrisis2: "The Trevor Project: 1-866-488-7386 or text START to 678-678  ·  Emergency: 911",
      planClose: "One breath at a time. The dawn has never once failed to arrive.",
      planToc: "My Safety Plan (fill-in)",
      plan: [
        ["1. My warning signs", "Thoughts, feelings, or situations that tell me a crisis may be building", 3],
        ["2. Things I can do on my own to cope", "Music, a walk, slow breathing, Sanctuary sounds, journaling", 3],
        ["3. People and places that comfort or distract me", "A friend's house, a park, a coffee shop, a place of worship", 2],
        ["4. People I can ask for help", "Name and phone number", 3],
        ["5. Professionals and agencies I can contact", "Doctor, counselor, school counselor, local crisis team", 2],
        ["6. Making my space safer", "Steps to keep myself safe, such as asking someone to hold medications or other dangerous items", 2],
        ["7. My reasons for living", "People, pets, dreams, and moments that matter to me", 3],
      ],
      coverTitle: "Information is Power", coverSub: "A School & Counselor Packet",
      coverNote: "Free to print and share with students, families, and staff.", contents: "CONTENTS",
      coverCrisis: "In crisis? Call or text 988, any time.",
    },
    files: { plan: "BSN-My-Safety-Plan", packet: "BSN-School-Counselor-Packet" },
  },
  es: {
    disclaimer: "Esta información es solo para fines educativos. No reemplaza la atención de un profesional de la salud calificado.",
    disclaimerLong: "Esta información es solo para fines educativos. No reemplaza la atención de un profesional de la salud calificado.",
    eyebrow: "La información es poder",
    forTeens: "La información es poder · Para jóvenes",
    toc: "En esta guía · toca para abrir",
    download: "Descargar PDF para imprimir",
    share: "Compartir esta guía",
    text: "Enviar por mensaje",
    copy: "Copiar enlace",
    downloading: "Tu guía para imprimir se está descargando.",
    copied: "Enlace y mensaje copiados. Pégalos donde quieras compartirlos.",
    shareMsg: (title, link) => `Me importas y esto me pareció útil: "${title}" de Bright Stories Network. ${link}`,
    helpNow: "Si necesitas ayuda ahora, llama al 988 (presiona 2) o envía AYUDA por texto al 988.",
    guidesTitle: "Entiende lo que está pasando y cómo ayudar",
    guidesSub: "Elige la guía que mejor se adapte a lo que necesitas ahora.",
    readGuide: "Leer esta guía →",
    packetTitle: "Para escuelas y consejeros",
    packetSub: "Todas las guías, la guía para jóvenes y el plan de seguridad para llenar, en un solo paquete para imprimir con portada e índice.",
    packetBtn: "Descargar el paquete",
    packetToast: "El paquete para escuelas y consejeros se está descargando.",
    planToast: "Tu plan de seguridad para llenar se está descargando.",
    pdf: {
      label: "LA INFORMACIÓN ES PODER", teens: "PARA JÓVENES", plan: "MI PLAN DE SEGURIDAD",
      crisis: "Llama al 988 (presiona 2) o envía AYUDA por texto al 988  ·  En peligro inmediato, llama al 911.",
      footerHelp: "¿Necesitas ayuda ahora? Llama al 988 (presiona 2).", readOnline: "Leer en línea", page: "Página", of: "de",
      planTitle: "Mi plan de seguridad",
      planIntro: "Llénalo en tu teléfono o computadora, o imprímelo y escríbelo a mano. Guárdalo donde lo puedas ver. Compártelo con alguien de confianza. Tú importas.",
      planCrisisH: "Si estoy en crisis ahora mismo",
      planCrisis1: "Línea 988 de Prevención del Suicidio y Crisis: llama al 988 y presiona 2, o envía AYUDA por texto al 988",
      planCrisis2: "The Trevor Project: 1-866-488-7386  ·  Emergencias: 911",
      planClose: "Una respiración a la vez. El amanecer nunca ha dejado de llegar.",
      planToc: "Mi plan de seguridad (para llenar)",
      plan: [
        ["1. Mis señales de alerta", "Pensamientos, sentimientos o situaciones que me indican que se puede estar formando una crisis", 3],
        ["2. Cosas que puedo hacer por mi cuenta para sobrellevarlo", "Música, una caminata, respirar despacio, los sonidos del Santuario, escribir en un diario", 3],
        ["3. Personas y lugares que me consuelan o me distraen", "La casa de un amigo, un parque, una cafetería, un lugar de culto", 2],
        ["4. Personas a quienes puedo pedir ayuda", "Nombre y número de teléfono", 3],
        ["5. Profesionales y servicios que puedo contactar", "Médico, consejero, consejero escolar, equipo local de crisis", 2],
        ["6. Hacer mi espacio más seguro", "Pasos para mantenerme a salvo, como pedirle a alguien que guarde medicamentos u otros objetos peligrosos", 2],
        ["7. Mis razones para vivir", "Personas, mascotas, sueños y momentos que me importan", 3],
      ],
      coverTitle: "La información es poder", coverSub: "Paquete para escuelas y consejeros",
      coverNote: "Gratis para imprimir y compartir con estudiantes, familias y personal.", contents: "CONTENIDO",
      coverCrisis: "¿En crisis? Llama al 988 (presiona 2), a cualquier hora.",
    },
    files: { plan: "BSN-Mi-Plan-de-Seguridad", packet: "BSN-Paquete-Escuelas-Consejeros" },
  },
};
